/**
 * icon-review.js
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Types } from 'utils/constants';
import Icon from 'components/icon';


export default function IconReview(props) {
  const {
    isComplete,
    status,
    to,
  } = props;
  let iconName = '';

  if (!isComplete) return null;

  switch (status) {
    default:
    case Types.ReviewStatus.NOT_REVIEWED:
      iconName = 'not-reviewed';
      break;

    case Types.ReviewStatus.ACCEPTED:
      iconName = 'accepted';
      break;

    case Types.ReviewStatus.REJECTED:
      iconName = 'rejected';
      break;
  }

  const baseContent = <Icon type={iconName} className={`icon-${iconName}`} />;

  const linkContent = to
    ? <Link to={to} style={{ display: 'flex' }}>
      {baseContent}
    </Link>
    : baseContent;
  
  return linkContent;
}